
import { css } from 'lit';
export default css`

:host{
  display:block;
}
  @media print{
:host{
    break-inside:avoid;
    page-break-inside:avoid
}
  }

.block{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4);
}

::slotted([slot='title']){
  font-weight:var(--fw-medium);
  font-size:var(--fs-body-mobile);
  line-height:var(--lh-body-mobile);
}

@media print{

::slotted([slot='title']){
    font-weight:var(--fw-semibold);
    font-size:var(--fs-xl);
    line-height:var(--fs-xl)
}
  }

@media print{
    :host(.author-block) ::slotted([slot='title']){
      color:var(--primary-eggplant);
      font-weight:var(--fw-light);
      font-size:var(--fs-h3);
      font-family:var(--ff-display);
    }
  }

::slotted([slot='content']){
  display:flex;
}

::slotted([slot='content'].grid-author){
  display:grid;
  grid-template-columns:repeat(1, minmax(0, 1fr));
  gap:1.5rem;
}

@media (min-width: 768px){
  ::slotted([slot='content'].grid-author){
    grid-template-columns:repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 992px){
  .block{
    gap:var(--spacing-6);
  }

  ::slotted([slot='title']){
    font-size:var(--fs-body);
    line-height:var(--lh-body);
  }

  ::slotted([slot='content'].grid-author){
    grid-template-columns:repeat(1, minmax(0, 1fr));
  }
}

@media print{
  ::slotted([slot='content'].grid-author){
    display:grid;
    grid-template-columns:repeat(3, minmax(0, 1fr));
    gap:1rem;
  }
}
`;